
 let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      $('body').addClass('menu-open');
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
        $('body').removeClass('menu-open');
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
      $('body').removeClass('menu-open');
    });
  });
  
  });
  


$(function(){

  $('.homepage-fp .product-grid').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
  
  $('body').on('click', '#size_guide', function(){
    $('.product-popup-modal__opener button').click();
  });
  $('.search-on-menu .search__input').click(function(){
    $('.header__icons details-modal.header__search details').attr('open', 'true');
    $('#Search-In-Modal').focus();
  });
  $('body').on('click', '.color-option .selected_color', function(){
    if($('#dropdownbox').hasClass('active')){
      $('#dropdownbox').hide().removeClass('active');
    }else{
      $('#dropdownbox').show().addClass('active');
    }
    
  });
  getcoloroptionandselect();
  $('body').on('click', '.color-option #dropdownbox .dropitem', function(){
    $('#dropdownbox').hide().removeClass('active');
    var $thisid = $(this).data('id');
    $('#'+$thisid).click();
    getcoloroptionandselect();
  });
  $('body').on('click', 'variant-selects fieldset label', function(){
    getcoloroptionandselect();
  });
  function getcoloroptionandselect(){
    var $colorvalue = $('.color-option input:checked').val();
    var $colorhandle = $('.color-option input:checked').data('handle');
    var datahtml = '<p class="color_dropdown_handle color_dropdown_val_'+$colorhandle+'" style="background-color:'+$colorhandle+'">&nbsp;</p><p class="droptext">'+$colorvalue+'</p>';
    $('body .selected_color_wrap').html(datahtml);
    var changecolorinterval = setInterval(function () {
      var datahtml = '<p class="color_dropdown_handle color_dropdown_val_'+$colorhandle+'" style="background-color:'+$colorhandle+'">&nbsp;</p><p class="droptext">'+$colorvalue+'</p>';
      $('body .selected_color_wrap').html(datahtml);
    }, 50);
    setTimeout(function(){
      clearInterval(changecolorinterval);
    }, 2000)
    
  }
});

document.addEventListener("DOMContentLoaded", function() {
  if(typeof Ajaxinate !== 'undefined'){
    var endlessScroll = new Ajaxinate({
      container: '#product-grid',
      pagination: '#Huratips-Pagination'
    });
  }
});